(function()
{
    //Import classes

    var BasePanel = include('WGBH.UIPanel'),
		Sprite = include('PIXI.Sprite'),
		Graphics = include('PIXI.Graphics'),
		Button=include("springroll.pixi.Button"),
		Container=include("PIXI.Container"),
		Text=include("PIXI.Text"),
		Point=include("PIXI.Point"),
		Texture = include('PIXI.Texture'),
		EventDispatcher=include('springroll.EventDispatcher');
    /**
     * Panel contains all of the visual elements for the index state
     * @class WGBH.IndexPanel
     * @extends PIXI.Container
     */
    var IndexPanel = function()
    {
        BasePanel.call(this);

    };



    //Extend the base panel
    var p = extend(IndexPanel, BasePanel);

	
	
    /**
     * Setup the state, this happens on each state entering
     */
    p.setup = function()
    {		
		this.background=new Sprite(images.bg_zoo);
		this.background.interactive=true;
		this.background.on(app.click,this.clickbackground);
		this.addChild(this.background);
		this.additem(app.config.index.createbutton);
		this.additem(app.config.index.playbutton);
		
		
    };

    /**
     * Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
    	// remove the children and stop the button events
    	
		this.background.off(app.click,this.clickbackground);
    };

    //Assign to namespace
    namespace('WGBH').IndexPanel = IndexPanel;
}());